import { clsx } from "@trydig/ui";
import { Children, type PropsWithChildren } from "react";
import styles from "./GridList.module.css";

export interface GridListProps extends PropsWithChildren {
	content?: React.JSX.Element[];
	header?: React.JSX.Element;
	className?: string;
}

export const GridList = ({
	children,
	content,
	header,
	className,
}: GridListProps) => {
	const renderedCards = Children.toArray(children).length;

	const wrappedContent = Children.toArray(content).map((item, index) => {
		const row = index * 2;
		const canRenderAsLargeCard = renderedCards / 2 >= row;

		if (!canRenderAsLargeCard) {
			// Render as normal item instead
			return <>{item}</>;
		}

		return (
			<div
				style={
					{
						"--content-row": row,
					} as React.CSSProperties
				}
				className={clsx(styles.contentItem, index === 0 && styles.first)}
				key={index}
			>
				{item}
			</div>
		);
	});
	return (
		<section className={clsx(styles.root, className)}>
			<header>{header}</header>
			<div className={styles.headerSpacing} />

			{children}
			{wrappedContent}
		</section>
	);
};
